<template>
    <v-container>
        <v-flex>
            <v-layout row class="my-2">
                <v-flex class="hidden-sm-and-down">
                    <h2>{{ txc.title }}</h2>
                </v-flex>
            </v-layout>
            <template>
                <ns-payment-manager
                    :use-billing-address="siteConfig.checkout.useNewBillingAddress"
                />
            </template>
            <ns-toast type="warning" message="There are new terms and conditions for your payment methods" cta-link="Edit Payment Methods"/>
        </v-flex>
    </v-container>
</template>

<script>
import { NsPaymentManager } from '@nuskin/app-elements'
import { mapGetters } from 'vuex'

export default {
    name: 'PaymentSection',
    components: { NsPaymentManager },
    computed: {
        ...mapGetters({
            fullscreen: 'mobileView',
            txc: 'translationsPayment',
            siteConfig: 'siteConfig'
        })
    }
}
</script>
